export enum EnumInvoiceState {
	/**
	 * 未取票
	 */
	未取票 = "1",
	/**
	 * 等待中
	 */
	等待中 = "2",
	/**
	 * 取票中
	 */
	取票中 = "3",
	/**
	 * 取票成功
	 */
	取票成功 = "4",
	/**
	 * 取票失败
	 */
	取票失败 = "5",
	/**
	 * 无票可取
	 */
	无票可取 = "6",
}

export enum UibotInvoiceState {
	/**
	 * 未取票
	 */
	未取票 = 1,
	/**
	 * 等待中
	 */
	等待中 = 2,
	/**
	 * 取票中
	 */
	取票中 = 3,
	/**
	 * 取票成功
	 */
	取票成功 = 4,
	/**
	 * 取票失败
	 */
	取票失败 = 5,
	/**
	 * 无票可取
	 */
	无票可取 = 6,
}

export const InvoiceStateList = () => {
	const list: { [x: string]: any; }[] = [];
	Object.keys(EnumInvoiceState).forEach(key => {
		list.push({
			// @ts-ignore
			id: EnumInvoiceState[key],
			text: key
		});
	});
	list.splice(0, 0, {
		id: "",
		text: "全部"
	});
	return list;
}
